import { CheckoutSkeleton } from "@punchup/ui-common/components/common";

export default CheckoutSkeleton;
